import Parse from 'html-react-parser';

function MockMain(props) {
    let svgCode =
    `<svg width="1800" height="1456" viewBox="0 0 1800 1456" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M577 290V393H330L577 290Z" fill="url(#paint0_linear)"/>
        <path d="M577 496V393H824L577 496Z" fill="url(#paint1_linear)"/>
        <path d="M330 393L577 291.5V494.5L824 393" stroke="${props.waveBG}" stroke-width="3"/>
        <defs>
        <linearGradient id="paint0_linear" x1="453.5" y1="290" x2="453.5" y2="393" gradientUnits="userSpaceOnUse">
        <stop stop-color="${props.waveBG}" stop-opacity="0.6"/>
        <stop offset="1" stop-color="${props.waveBG}" stop-opacity="0.2"/>
        </linearGradient>
        <linearGradient id="paint1_linear" x1="700.5" y1="496" x2="700.5" y2="393" gradientUnits="userSpaceOnUse">
        <stop stop-color="${props.waveBG}" stop-opacity="0.6"/>
        <stop offset="1" stop-color="${props.waveBG}" stop-opacity="0.2"/>
        </linearGradient>
        </defs>
        
        <g stroke="${props.envFill}">
        <path d="M205.973 831.992C234.263 933.754 283.418 978.903 394 1008.29V1093H168L205.973 831.992Z" fill="url(#paint3_linear)" stroke-width="0"/>
        <path d="M166 1094L205.413 830.996C205.413 830.996 225.834 913.345 272.266 951.17C330.107 998.29 393 1008.3 393 1008.3V1094" stroke-width="3"/>
        <ellipse cx="205.5" cy="834.483" rx="4.5" ry="4.48302" fill="${props.envFill}"/>
        <ellipse cx="392.5" cy="1008.82" rx="4.5" ry="4.48302" fill="${props.envFill}"/>
        <path d="M290 961.502C290 963.697 288.213 965.483 286 965.483C283.787 965.483 282 963.697 282 961.502C282 959.307 283.787 957.521 286 957.521C288.213 957.521 290 959.307 290 961.502Z" stroke-width="2"/>
        <path d="M189 965.487C189 967.682 187.213 969.468 185 969.468C182.787 969.468 181 967.682 181 965.487C181 963.292 182.787 961.506 185 961.506C187.213 961.506 189 963.292 189 965.487Z" stroke-width="2"/>
        <path d="M1124.5 835.91L1481 1093.01H767.5L1124.5 835.91Z" fill="url(#paint4_linear)" stroke-width="0"/>
        <path d="M766.5 1093.5L1124 835.421L1481 1093.01" stroke-width="3"/>
        <ellipse cx="1124.5" cy="836.399" rx="4.5" ry="4.39907" fill="${props.envFill}"/>
        <path d="M1317 971.793C1317 973.919 1315.23 975.68 1313 975.68C1310.77 975.68 1309 973.919 1309 971.793C1309 969.667 1310.77 967.905 1313 967.905C1315.23 967.905 1317 969.667 1317 971.793Z" stroke-width="2"/>
        <path d="M939 971.793C939 973.919 937.231 975.68 935 975.68C932.769 975.68 931 973.919 931 971.793C931 969.667 932.769 967.905 935 967.905C937.231 967.905 939 969.667 939 971.793Z" stroke-width="2"/>
        </g>
        <defs>
        <linearGradient id="paint3_linear" x1="281" y1="831.992" x2="281" y2="1093" gradientUnits="userSpaceOnUse">
        <stop stop-color="${props.envFill}" stop-opacity="0.5"/>
        <stop offset="1" stop-color="#C4C4C4" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint4_linear" x1="1173" y1="833.955" x2="1173" y2="1090.08" gradientUnits="userSpaceOnUse">
        <stop stop-color="${props.envFill}" stop-opacity="0.5"/>
        <stop offset="1" stop-color="#C4C4C4" stop-opacity="0"/>
        </linearGradient>
        </defs>
    </svg>`

    const style = {
        position: "absolute",
        overflow: "hidden",
        top: "0px",
        left: "0px",
        display: props.display
        // transform: "scale(2.4)"
    }

    const inStyle = {
        marginTop: "0px"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
            {Parse(svgCode)}
            </div>
        </div>
    );
}

export default MockMain;